const workflowStepsMap = {
  shopping_cart: 0,
  registration: 1,
  shipment: 2,
  billing: 3,
  payment: 4,
}
export default workflowStepsMap
